export default __webpack_public_path__ + "static/media/squeezeJarSpringHoney.fec4836d.jpg";